import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollExportEmployeeDTO  {
    _originalTypeClassName = "zERP.BO.PayrollExportEmployeeDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollExportEmployeeDTO.translate = translateService;
}
this.Items = [];
this.EmployeeId = null;
this.EmployeeCode = null;
this.DaysWorked = null;
this.Overtimes = null;
this.AdvanceAmount = null;
this.PayrollExportEmployeeDTOKey = null;
this._key = this.PayrollExportEmployeeDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
EmployeeId:any;
EmployeeCode:any;
DaysWorked:any;
Overtimes:any;
AdvanceAmount:any;
Items:any;
private _PayrollExportEmployeeDTOKey:any;
get PayrollExportEmployeeDTOKey(): any {
    return this._PayrollExportEmployeeDTOKey;
  }
set PayrollExportEmployeeDTOKey(value: any) {
    this._PayrollExportEmployeeDTOKey = value;
    this._key = value;
  }
static setItems = ($this, items) => {
                if (items == null) items = [];
                if ($this.Items == null) $this.Items = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Items.length > 0) {
                    Domain.PayrollExportEmployeeDTO.removeItems($this, $this.Items[0]);
                }

                Domain.PayrollExportEmployeeDTO.addManyItems($this, copyItems);
            }
static addManyItems = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PayrollExportEmployeeDTO.addItems($this, items[i]);
                }
            }
static addItems = ($this, item) => {
                if ($this.Items == null) $this.Items = [];
                if (item == null || $this.Items.indexOf(item) > -1) return;
                $this.Items.push(item);
}
static addRangeItems = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PayrollExportEmployeeDTO.addItems($this, item));
            }
static removeItems = ($this, item) => {
                if ($this == null || $this.Items == null || $this.Items.indexOf(item) === -1) return;
                var _index = $this.Items.indexOf(item);
                $this.Items.splice(_index, 1);
}
static clearItems = ($this) => { $this.Items = null; }

static Exprot(ep: any): any{let dto = new Domain.PayrollExportEmployeeDTO();
dto.DaysWorked = ep?.DaysWorked;
dto.Overtimes = ep?.Overtimes;
dto.EmployeeId = ep?.Contract?.Id;
dto.EmployeeCode = ep?.Employee?.Code;
dto?.Items?.addRange(ep?.Salaries?.linq?.select((s) => Domain.PayrollExportItemDTO.ExportSalary(s))?.toArray());
dto?.Items?.addRange(ep?.Contributions?.linq?.select((s) => Domain.PayrollExportItemDTO.ExportContribution(s))?.toArray());
dto?.Items?.addRange(ep?.Deductions?.linq?.select((s) => Domain.PayrollExportItemDTO.ExportDeduction(s))?.toArray());
return dto;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollExportEmployeeDTOKey == null || $this.PayrollExportEmployeeDTOKey == 0;
            }


}